import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { ApiPaths } from "../../../api/paths";
import ActiveShieldIcon from "../../../components/icons/ActiveShieldIcon";
import ShieldCard from "../../../components/shield-card/ShieldCard";
import useData from "../../../hooks/use-data";
import { ClaimStatisticsType } from "../../../types/claim";
import { useAppContext } from "../../../context/app-context";
import { toast } from "react-toastify";

export default function MyClaimsStats() {
  const { keycloakProfile } = useAppContext();
  const { t } = useTranslation(["myClaims"]);
  const params = useMemo(
    () => ({
      params: {
        search: keycloakProfile?.email,
      },
    }),
    [keycloakProfile?.email]
  );
  const { data } = useData<ClaimStatisticsType>(ApiPaths.claimsStatistics, {
    options: params,
    onError: () => {
      toast(t("mutate_Profile.error.fetch_single", { ns: "myProfile" }), {
        type: "error",
      });
    },
    fetchIf: !!keycloakProfile?.email,
  });
  const mapData = useMemo(
    () => [
      {
        name: t("stats.total_claims", { ns: "myClaims" }),
        qty: data?.claimStatistics?.total_claims,
        color: "bg-purple-light",
        shieldColor: "bg-purple",
        tooltip: t("stats.tooltip.total_claims", { ns: "myClaims" }),
        icon: <ActiveShieldIcon />,
      },
      {
        name: t("stats.approved_claims", { ns: "myClaims" }),
        qty: data?.claimStatistics?.approved_claims,
        color: "bg-green-light",
        shieldColor: "bg-green",
        tooltip: t("stats.tooltip.approved_claims", { ns: "myClaims" }),
        icon: <ActiveShieldIcon />,
      },
      {
        name: t("stats.pending_claims", { ns: "myClaims" }),
        qty: data?.claimStatistics?.pending_claims,
        color: "bg-orange-light",
        shieldColor: "bg-orange",
        tooltip: t("stats.tooltip.pending_claims", { ns: "myClaims" }),
        icon: <ActiveShieldIcon />,
      },
      {
        name: t("stats.rejected_claims", { ns: "myClaims" }),
        qty: data?.claimStatistics?.rejected_claims,
        color: "bg-orange-light",
        shieldColor: "bg-orange",
        tooltip: t("stats.tooltip.rejected_claims", { ns: "myClaims" }),
        icon: <ActiveShieldIcon />,
      },
    ],
    [data]
  );
  return (
    <div className="row ">
      {mapData.map((stat) => {
        return (
          <div className="col-6 col-md-3 pb-3" key={stat.name}>
            <ShieldCard
              name={stat.name}
              qty={stat.qty}
              color={stat.color}
              shieldColor={stat.shieldColor}
              tooltip={stat.tooltip}
              icon={stat.icon}
            />
          </div>
        );
      })}
    </div>
  );
}
